import * as moment from 'moment';
import {
  ApiProviderResponse,
  ApiProviderVisitResponse,
  ApiProviderVisitValidationRequest,
  ApiProviderVisitValidationResponse,
  ApiProviderVisitValidationResult,
  ApiProviderVisitVerificationResponse,
} from 'src/app/core/models';

const today = moment().startOf('day');

const providers: ApiProviderResponse[] = [
  {
    doctorId: 1,
    firstName: 'VANITA',
    lastName: 'TREAT',
    phoneNumber: '6105271604',
    addressLine1: '3891 RANCHVIEW DR.',
    addressCity: 'RICHARDSON',
    addressState: 'CALIFORNIA',
    addressZip: '62639',
  },
  {
    doctorId: 2,
    firstName: 'STEVEN',
    lastName: 'BAUGHN',
    phoneNumber: '1234567890',
    addressLine1: '1234 TEST ROAD',
    addressLine2: 'APT 1',
    addressCity: 'FAKEPLACE',
    addressState: 'NEW YORK',
    addressZip: '65432-1234',
  },
];

const visitVerificationDaysBefore = 14;
const visitVerificationDaysAfter = 14;

const providerVisitVerification = [
  {
    visitVerificationRequired: true,
    visitVerificationDaysBefore,
    visitVerificationDaysAfter,
  },
];

const providerVisits = [
  {
    doctorId: 1,
    visitDate: today
      .clone()
      .subtract(visitVerificationDaysBefore - 2, 'days')
      .format(),
  },
  {
    doctorId: 1,
    visitDate: today
      .clone()
      .subtract(visitVerificationDaysBefore + 2, 'days')
      .format(),
  },
  {
    doctorId: 2,
    visitDate: today
      .clone()
      .subtract(visitVerificationDaysBefore + 5, 'days')
      .format(),
  },
];

export const getProviderVisits = (): ApiProviderVisitResponse[] => providerVisits;

export const getProviderVisitVerification = (): ApiProviderVisitVerificationResponse[] => providerVisitVerification;

export const getProviders = (): ApiProviderResponse[] => providers;

export const validateProviderVisit = (
  _: any,
  body: ApiProviderVisitValidationRequest
): ApiProviderVisitValidationResponse => ({
  validationResult: moment(body.visitDate).isBefore(moment(), 'days')
    ? ApiProviderVisitValidationResult.VisitDateTooOldCgm
    : ApiProviderVisitValidationResult.PvvIsValid,
});
